import * as React from 'react';

import * as styles from './OptionTile.module.less';

interface IOptionTileProps {
  title: string;
  imageSrc: string;
  srcSet?: string;
  selected: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
}

export const OptionTile: React.FunctionComponent<IOptionTileProps> = ({
  title,
  imageSrc,
  srcSet,
  selected,
  onClick,
  style,
}) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  return (
    <div
      className={`${styles.container} ${selected ? styles.selected : ''}`}
      onClick={onClick}
      style={style}
    >
      <div className={styles.image}>
        {!imageLoaded && <div className={styles.placeholder} />}
        <img
          src={imageSrc}
          srcSet={srcSet}
          alt={title}
          onLoad={() => setImageLoaded(true)}
          style={{ opacity: imageLoaded ? 1 : 0 }}
        />
      </div>
      <div className={styles.label}>{title}</div>
      <div className={styles.checkmark} />
    </div>
  );
};
